const _ = require('lodash');

module.exports = class Env {
	static isDevelopment () {
		return _.includes([
			'localhost',
			'iterable.test',
			'itbl.local',
		], window.location.hostname);
	}
}